export default __webpack_public_path__ + "static/media/mail-sent.0b8180c9.svg";